"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),i=require("react/jsx-runtime"),t=require("@vds/tiles"),a=require("@vds/type-lockups"),r=require("styled-components"),n=require("@vds-tokens/core"),d=require("@vds/utilities"),s=require("@plans/utilities"),l=require("@vds/icons");function o(e){return e&&e.__esModule?e:{default:e}}var p=o(r);const c=p.default.div.withConfig({displayName:"TileWrapper",componentId:"VDS__sc-1hijcag-0"})`
  align-items: center;
  display: flex;
  width: 100%;
  > div {
    > div {
      border-radius: 24px;
      > div {
        border-radius: ${({inline:e})=>e?"24px":"16px"} !important;
        padding: ${({Tileletpadding:e})=>e} !important;
        /* padding: ${({inline:e})=>e?"0px":"24px 24px 64px 24px"} !important; */
        @media (max-width: ${s.breakpoints.mobileLarge.max}) {
          /* padding: ${({inline:e})=>e?"0px":"24px"} !important; */
          border-radius: 24px !important;
        }
        &::before {
          border-radius: ${({inline:e})=>e?"24px":"16px"} !important;
          @media (max-width: ${s.breakpoints.mobileLarge.max}) {
            border-radius: 24px !important;
          }
        }
      }
    }
    border-radius: ${({inline:e})=>e?"24px":"16px"} !important;
    @media (max-width: ${s.breakpoints.mobileLarge.max}) {
      border-radius: 24px !important;
    }
  }
`,u=p.default.div.withConfig({displayName:"TitleLockupWrapper",componentId:"VDS__sc-1hijcag-1"})`
  span {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    overflow: hidden;
  }
`,x=p.default.div.withConfig({displayName:"ContentWrapper",componentId:"VDS__sc-1hijcag-2"})`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`,m=p.default.div.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-1hijcag-3"})`
  height: 24px;
  margin-left: ${n.LayoutTokens.space["6X"].value};
  min-width: 24px;
  width: 24px;
  svg {
    path {
      fill: ${({surface:e})=>n.ColorTokens.elements.primary[`on${e||"light"}`].value};
    }
  }
  @media (max-width: ${s.breakpoints.mobileLarge.max}) {
    width: 20px;
    min-width: 20px;

    height: 20px;
    margin-left: ${n.LayoutTokens.space["3X"].value};
  }
`;var g=d.withVDSManager((r=>{var{variant:n="base",title:d,subtitle:s,viewport:o,padding:p,directionalIcon:g,surface:h,height:b}=r,v=e.__rest(r,["variant","title","subtitle","viewport","padding","directionalIcon","surface","height"]);const f="mobile"===o,j=f?"210px":"246px",k=b||(f?"200px":"256px");return"inline"===n?i.jsx(c,Object.assign({inline:!0},{children:i.jsx(t.TileContainer,Object.assign({padding:p||(f?"16px":"24px"),height:"auto"},v,{children:i.jsxs(x,{children:[i.jsx(u,{children:i.jsx(a.TitleLockup,Object.assign({surface:"black"===v.backgroundColor?"dark":"light"},{children:d&&i.jsx(a.TitleLockupTitle,Object.assign({size:"titleMedium"},d,{primitive:"span"}))}))}),i.jsx(m,Object.assign({surface:"black"===v.backgroundColor?"dark":"light"},{children:i.jsx(l.Icon,Object.assign({name:"right-arrow",surface:h,size:(null==g?void 0:g.size)?null==g?void 0:g.size:f?"medium":"large"},g))}))]})}))})):i.jsx(c,Object.assign({Tileletpadding:p},{children:i.jsx(t.Tilelet,Object.assign({textWidth:j,backgroundColor:"dark"===h?"gray":"black",title:d,subtitle:s},v,{height:k,directionalIcon:g?{size:f?"medium":"large"}:void 0}))}))}));exports.default=g;
